/** ASCII-fold + lowercase + hyphenate. Strips Vietnamese diacritics. */
export function slugify(input: string): string {
  return input
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80);
}

/** Slug with a short timestamp suffix — collision-resistant for user content. */
export function slugifyWithTimestamp(input: string): string {
  const base = slugify(input) || 'item';
  const suffix = Date.now().toString(36);
  return `${base}-${suffix}`;
}
